
import { Component, Prop, Vue } from "vue-property-decorator";

type Operations = "min" | "eq" | "max";
type NumericOption = {
  label: string;
  start?: number;
  end?: number;
};

@Component({
  name: "ci-ais-numeric-menu",
})
export default class extends Vue {
  @Prop({ required: true }) public attribute!: string;
  @Prop({ default: "" }) public label!: string;
  @Prop({ default: false }) public icons!: boolean;
  @Prop({ default: 5 }) public options!: number;
  @Prop({ default: "min" }) public operation!: Operations;

  public get mappedOptions(): NumericOption[] {
    const items = [];
    for (let i = 1; i <= this.options; i++) {
      items.push(this.createOption(i, this.options, this.operation));
    }

    return items;
  }

  private createOption(i: number, max: number, operation: Operations): NumericOption {
    switch (operation) {
      case "eq":
        return { label: i.toString(), start: i, end: i };
      case "min":
        return i > 1 ? { label: i.toString(), start: i } : { label: i.toString() };
      case "max":
        return i < max ? { label: i.toString(), end: i } : { label: i.toString() };
      default:
        throw new Error(`Unkown operation: ${operation}`);
    }
  }
}
